

$(window).on('scroll', function() {
	
	
		var $ScrollTop = $(this).scrollTop();
		var $menupart = $("header").find(".header__top");
	
	   
		if($ScrollTop > 0) {
		
		  if ($(window).width() > 767) {
			$menupart.addClass("p-md-0");
			$menupart.css({
			  "opacity": "0",
			  "visibility": "hidden",
			  "height": "0",
			});
		  }


		
		}

		else {
			$menupart.removeClass("p-md-0");
		  $menupart.css({
			"opacity": "1",
			"visibility": "visible",
			"height": "auto",
		  });
		  }

		
});

$('body').on('click', '.sideNav-btn', function() {
	$('.menu-part').toggleClass('open');
	$(this).toggleClass('active');
});

$('body').on('click', '.item--scroll', function() {
	var $id = $(this).attr('data-key');
	$("html, body").animate({ scrollTop: $(""+$id+"").offset().top-170}, 500);
	$(""+$id+"").trigger('click');
});

$('.header-dropdown__head').on('mouseenter', function() {
	$(this).addClass('active visible');
	$(this).parents('.ui.dropdown').find('.menu').addClass('visible transition').css({
		"display": "block !important"
	});
})


$('.header-dropdown__head').on('click', function() {
	var $href = $(this).attr('href');
	window.location.href = $href;
})


$('.header-dropdown').on('mouseleave', function() {
	$(this).find('.header-dropdown__head').removeClass('active visible');
	$(this).find('.menu').removeClass('visible transition').css({
		"display": "none !important"
	});
	$('.menu-part').toggleClass('open');
	$('.sideNav-btn').toggleClass('active');
})
